import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';

export class ClientProjects extends Component {
    columns = [
        { title: 'Проект', field: 'name' },
        { title: 'План, ч', field: 'planHours' },
        { title: 'Клиентские часы', field: 'clientHours' },
        { title: 'Факт, ч', field: 'factHours' },
        { title: 'Согласовано', field: 'approvedHours' },
        { title: 'Приоритет', field: 'priority' },
        { title: 'Состояние', field: 'status' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.loadProjects = this.loadProjects.bind(this);
        this.handleProjectEdit = this.handleProjectEdit.bind(this);
    }

    componentDidMount() {
        if (this.props.accountId)
        this.loadProjects();
    }

    componentDidUpdate(prevProps) {
        if (this.props.accountId && prevProps.accountId !== this.props.accountId)
            this.loadProjects();
    }

    loadProjects() {
        var scope = this;
        scope.setState({ loading: true});
        var token = localStorage.getItem("token");
        fetch('api/Account/projects?accountId=' + this.props.accountId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ costs: result, loading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleProjectEdit(project) {
        var scope = this;
        scope.setState({ loading: true });
        var token = localStorage.getItem("token");
        fetch('api/Project/GetProjectMainInfo?id=' + project.id, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ loading: false });
                    MainStore.openProjectDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        return (
            <div>
                <h3>Проекты</h3>
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <MaterialTable
                    title=""
                    columns={this.columns}

                    data={this.state.costs}
                    editable={{
                    }}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Редактировать',
                            isFreeAction: false,
                            onClick: (event, rowData) => {
                                this.handleProjectEdit(rowData);
                            }
                        },
                    ]}
                />}
            </div>
        )
    }
}